import { render, staticRenderFns } from "./CompanyFulfillmentDocumentsListComponent.vue?vue&type=template&id=312ff180&"
import script from "./CompanyFulfillmentDocumentsListComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyFulfillmentDocumentsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports